import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from './layout';

const MainLayoutRouter = ({ component: Component, name, roles, ...rest }) => (
    <Route
        {...rest}
        render={matchProps => (
            <MainLayout {...matchProps} name={name || ''} roles={roles || null}>
                <Component {...matchProps} />
            </MainLayout>
        )}
    />
);

export default MainLayoutRouter;
